import { useIntl } from "react-intl"

import { Feed } from "@doktor-se/bones-ui/dist/web-shared/components"
import { Account, AnyMessage, Conversation, Profile } from "@doktor-se/bones-ui/dist/web-shared/types"

import { conversationSeen, fetchSignedUrl } from "api"
import { appStatic, featureFlags } from "config"
import { useAppDispatch, useAppSelector } from "lib/hooks"
import { categorySelectors } from "reducers/categories"
import { filterMessages } from "reducers/conversations/utils/filter"
import { queueSelectors } from "reducers/queue/queue.reducer"

import { feedTexts } from "pages/dashboard/utils"

import styles from "./ConversationFeed.module.scss"

const ConversationFeed = ({
  conversation,
  profile,
  patient
}: {
  conversation: Conversation
  profile?: Profile
  patient?: Account
}) => {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const appLanguage = useAppSelector(state => state.app.language)
  const allStaff = useAppSelector(state => state.users.staff)
  const categories = useAppSelector(categorySelectors.selectEntities)
  const queues = useAppSelector(queueSelectors.selectAll)
  const user = useAppSelector(state => state.auth.user)
  const texts = feedTexts(intl, queues, appLanguage)
  const conversationWithPatient = {
    ...conversation,
    account: patient
  }

  return (
    <div className={styles.conversationFeedWrapper}>
      <Feed
        className={styles.conversationFeedContainer}
        conversation={conversationWithPatient}
        conversationIdForFilteredMessages={conversation.id}
        messagesToDisplaySearched={filterMessages(conversation.messages as AnyMessage[], conversation.patientId)}
        viewOnly
        staff={allStaff}
        categories={categories}
        conversationSeen={(conversationId, messageId) => dispatch(conversationSeen(conversationId, messageId))}
        loaderForFileUpload={false}
        features={featureFlags}
        texts={texts}
        user={user!}
        appStatic={appStatic}
        phrasesVariableOpts={{}}
        formSummaryVersion="v2"
        fetchSignedUrl={(key: string) => dispatch(fetchSignedUrl(key, conversation?.id))}
        patientProfiles={profile ? [profile] : []}
      />
    </div>
  )
}

export default ConversationFeed
